import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import EmptyData from "go-core/components/EmptyData";
import { LoadingContainer } from "go-core/components/Loading";
import { organizationApi } from "../../../../services/Api/Organization/organizationApi";
import { OrganizationMeApi } from "../../../../services/Api/types";
import { selectUser } from "../../../../services/users/selectors";
import { UserOrganizationState } from "../../../../services/users/types";

const EnterApplicationPage = () => {
	const [loading, setLoading] = useState(true);
	const user = useSelector(selectUser);
	const { addFlash } = useFlash();
	const urlSearchParams = new URLSearchParams(window.location.search);
	const [matchedOrg, setMatchedOrg] = useState<OrganizationMeApi | UserOrganizationState | undefined>(undefined);
	const companyId = urlSearchParams.get("company_id");
	const redirectPage = urlSearchParams.get("redirect_page") ? `/${urlSearchParams.get("redirect_page")}` : "";
	const { t } = useTranslation();

	useEffect(() => {
		handleInit();
	}, [user]);

	const handleInit = async () => {
		const org = user?.organizations?.find((f) => f.company_id === companyId);
		if (org) {
			setMatchedOrg(org);
		} else if (companyId) {
			await fetchOrganization();
		}
		setLoading(false);
	};

	const fetchOrganization = async () => {
		try {
			const res = await organizationApi.getOrganizationMe(companyId!);
			setMatchedOrg(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (loading) {
		return <LoadingContainer />;
	}
	if (matchedOrg) {
		return <Redirect to={`/${matchedOrg.id}${redirectPage}`} />;
	}

	if (!companyId) {
		return <Redirect to={"/"} />;
	}

	return (
		<div className="content">
			<EmptyData
				title={t("modules.enter_application.field.empty_data.title")}
				description={t("modules.enter_application.field.empty_data.description")}
			/>
		</div>
	);
};
export default EnterApplicationPage;
